/**
* @file Period validator, to check that start begins before finish.
* @author Tom Verschoore de la Houssaije
*/
import { Validator } from 'breeze-client';
// How to make custom validators:
// http://breeze.github.io/doc-js/validation.html
var NAME_PERIOD_VALIDATOR = 'period';
/**
 * This validator validates that the finish date is greater than start date.
 */
export function PeriodValidator() {
    var name = NAME_PERIOD_VALIDATOR;
    var contxt = {};
    var validator = new Validator(name, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        if (!(value instanceof Date)) {
            // Invalid date is checked by another validator.
            return true;
        }
        var PROPERTY_START = 'Start';
        var PROPERTY_FINISH = 'Finish';
        var PROPERTY_NAME = 'propertyName';
        var ENTIY = 'entity';
        var start = value;
        var finish = value;
        switch (context[PROPERTY_NAME]) {
            case PROPERTY_START:
                finish = context[ENTIY][PROPERTY_FINISH];
                break;
            case PROPERTY_FINISH:
                start = context[ENTIY][PROPERTY_START];
                break;
            default:
                throw new Error('Period validator can only be used with start or finish not with property: '
                    + context[PROPERTY_NAME]);
        }
        if (start <= finish) {
            if (context && context.entity) {
                var entity = context.entity;
                var errors = entity.entityAspect.getValidationErrors();
                if (errors) {
                    var validatorKey_1 = NAME_PERIOD_VALIDATOR + ':' + PROPERTY_START;
                    if (context.propertyName === PROPERTY_START) {
                        // I have to remove the other validation error.
                        validatorKey_1 = NAME_PERIOD_VALIDATOR + ':' + PROPERTY_FINISH;
                    }
                    var error = errors.find(function (item) { return item.key === validatorKey_1; });
                    if (error) {
                        entity.entityAspect.removeValidationError(error);
                    }
                }
            }
            return true;
        }
        return false;
    }
}
// You must register the validator.
// TODO: Maak hiervan een label key ter vertaling
Validator.messageTemplates[NAME_PERIOD_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.PERIOD';
Validator.register(PeriodValidator());
